module.exports = __webpack_public_path__ + "img/in-person.96db850e.png";